<div [formGroup]="form">
  <div class="date-page">
    <div
      class="row no-gutters"
      *ngIf="!useDateRange"
    >
      <div class="col reservation-date">
        {{
        (firstSelectedDate ? firstSelectedDate : currentDate)
        | date: "MMMM d, y" : "UTC"
        }}
      </div>
    </div>
    <div
      class="row no-gutters"
      *ngIf="useDateRange"
    >
      <div class="col-5 reservation-date">
        {{
        (firstSelectedDate ? firstSelectedDate : currentDate)
        | date: "MMMM d, y" : "UTC"
        }}
      </div>
      <div class="col-5 ml-auto reservation-date">
        {{ lastSelectedDate | date: "MMMM d, y" : "UTC" }}
      </div>
    </div>
    <mat-calendar
      class="date-picker"
      aria-label="calendar"
      [selected]="dateRange"
      (selectedChange)="onSelect($event)"
    ></mat-calendar>
    <hr />
    <footer class="footer-action">
      <button
        class="btn btn-danger btn-block"
        (click)="onSave()"
        [disabled]="!isSaveEnabled()"
      >
        Continue
      </button>
    </footer>
  </div>
</div>
